import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/analisis-completo")({
  beforeLoad: () => {
    throw redirect({ to: "/detector-de-fugas", statusCode: 301 });
  },
});
